module.exports = __webpack_public_path__ + "img/隨緣自強1.5 的副本.29169705.jpg";